import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    name: Yup.string()
        .required('Name is required')
        .max(200, 'Name must not exceed 200 characters'),
    parentId: Yup.string().nullable(),
    description: Yup.string().max(
        1000,
        'Description must not exceed 1000 characters',
    ),
    sku: Yup.string().max(100, 'SKU must not exceed 100 characters'),
    offeringId: Yup.string().max(
        100,
        'Offering ID must not exceed 100 characters',
    ),
    visibility: Yup.string().required('Visibility is required'),
    rule: Yup.string().nullable(),
});

export const visibilityOptions = [
    { value: 'visible', label: 'Visible' },
    { value: 'hidden', label: 'Hidden' },
];

export const ruleOptions = [
    { value: 'optional' || 'can', label: 'Optional' },
    { value: 'required' || 'must', label: 'Required' },
];

const formatRuleValue = (value) => {
    if (value === 'required' || value === 'must') return 'Required';
    if (value === 'optional' || value === 'can') return 'Optional';
    return '—';
};

export const CATALOG_COLUMNS = [
    {
        headerName: 'Name',
        field: 'name',
        sortable: true,
        resizable: true,
        flex: 1.2,
        minWidth: 160,
    },
    {
        headerName: 'Parent',
        field: 'parentName',
        sortable: true,
        resizable: true,
        flex: 1,
        minWidth: 150,
        cellRenderer: (params) => params.value || '—',
    },
    {
        headerName: 'Description',
        field: 'description',
        sortable: true,
        resizable: true,
        flex: 2,
        minWidth: 200,
        cellRenderer: (params) => params.value || '—',
    },
    {
        headerName: 'SKU',
        field: 'sku',
        sortable: true,
        resizable: true,
        flex: 1,
        minWidth: 130,
        cellStyle: { fontFamily: 'monospace', fontSize: '12px' },
        cellRenderer: (params) => params.value || '—',
    },
    {
        headerName: 'Offering ID',
        field: 'offeringId',
        sortable: true,
        resizable: true,
        flex: 1.2,
        minWidth: 160,
        cellStyle: { fontFamily: 'monospace', fontSize: '12px' },
        cellRenderer: (params) => params.value || '—',
    },
    {
        headerName: 'Visibility',
        field: 'visibility',
        sortable: true,
        resizable: true,
        flex: 0.8,
        minWidth: 110,
        cellRenderer: (params) =>
            params.value === 'hidden' ? 'Hidden' : 'Visible',
    },
    {
        headerName: 'Rule',
        field: 'rule',
        sortable: true,
        resizable: true,
        flex: 0.7,
        minWidth: 90,
        filter: 'agSetColumnFilter',
        valueFormatter: (params) => formatRuleValue(params.value),
        cellRenderer: (params) => formatRuleValue(params.value),
        filterParams: {
            valueFormatter: (params) => formatRuleValue(params.value),
        },
    },
    {
        maxWidth: 100,
        headerName: 'Action',
        filter: false,
        suppressMovable: true,
        sortable: false,
        lockPosition: 'right',
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }),
        cellRenderer: 'actionCellRenderer',
    },
];
